import { FieldConfig } from "../../../interfaces/ISginUpSignInForm";

export const signUpFieldsList: FieldConfig[] = [
  {
    name: "email",
    label: "E-mail",
    type: "email",
    required: true,
    autocomplete: "email",
  },
  {
    name: "phoneNumber",
    label: "Telefon",
    type: "tel",
    required: true,
    autocomplete: "tel",
  },
  {
    name: "password",
    label: "Hasło",
    type: "password",
    required: true,
    autocomplete: "new-password",
  },
  {
    name: "repeatedPassword",
    label: "Powtórz hasło",
    type: "password",
    required: true,
    autocomplete: "new-password",
  },
  {
    name: "firstName",
    label: "Imię",
    type: "text",
    required: true,
    autocomplete: "given-name",
  },
  {
    name: "lastName",
    label: "Nazwisko",
    type: "text",
    required: true,
    autocomplete: "family-name",
  },
  {
    name: "organizationName",
    label: "Nazwa organizacji",
    type: "text",
    required: true,
    autocomplete: "organization",
  },
];

export const signInFieldsList: FieldConfig[] = [
  {
    name: "email",
    label: "E-mail",
    type: "email",
    required: true,
    autocomplete: "username",
  },
  {
    name: "password",
    label: "Hasło",
    type: "password",
    required: true,
    autocomplete: "current-password",
  },
];

export const resetPasswordFieldsList: FieldConfig[] = [
  {
    name: "email",
    label: "E-mail",
    type: "email",
    required: true,
    autocomplete: "email",
  },
];
